import React from 'react';
import ResizableChart from './ResizableChart';
import TelemetryGraph from './TelemetryGraph';

export default function ChartSlot({
  channel,
  selectableChannels,
  onChannelChange,
  collapsed,
  onToggleCollapse,
  defaultHeight,
  laps,
  trackCoordinates,
  width,
  samplingMode,
  viewStyle,
  crosshairPos,
  onCrosshairChange,
  zoomRange,
  onZoomChange,
  onDragRangeChange,
  segmentBands,
  xAxisMode,
  user,
}) {
  return (
    <div>
      <div style={styles.header}>
        <button onClick={onToggleCollapse} style={styles.collapseBtn}>
          <svg width="12" height="12" viewBox="0 0 12 12" style={{
            transform: collapsed ? 'rotate(-90deg)' : 'rotate(0deg)',
            transition: 'transform 0.15s',
          }}>
            <path d="M3 2 L9 6 L3 10" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <select
          value={channel.key}
          onChange={(e) => onChannelChange(e.target.value)}
          style={styles.dropdown}
        >
          {selectableChannels.map((ch) => (
            <option key={ch.key} value={ch.key}>
              {ch.label}{ch.unit ? ` (${ch.unit})` : ''}
            </option>
          ))}
        </select>
      </div>
      {!collapsed && (
        <ResizableChart defaultHeight={defaultHeight}>
          {(h) => (
            <TelemetryGraph
              laps={laps}
              channel={channel}
              trackCoordinates={trackCoordinates}
              width={width}
              height={h}
              samplingMode={samplingMode}
              viewStyle={viewStyle}
              crosshairPos={crosshairPos}
              onCrosshairChange={onCrosshairChange}
              zoomRange={zoomRange}
              onZoomChange={onZoomChange}
              onDragRangeChange={onDragRangeChange}
              segmentBands={segmentBands}
              xAxisMode={xAxisMode}
              user={user}
            />
          )}
        </ResizableChart>
      )}
    </div>
  );
}

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '6px 0',
  },
  collapseBtn: {
    background: 'none',
    border: 'none',
    color: 'var(--color-secondary, #8AB4C8)',
    cursor: 'pointer',
    padding: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.7,
  },
  dropdown: {
    background: '#0D1B2A',
    color: 'var(--color-text, #E0E0E0)',
    border: '1px solid rgba(138,180,200,0.25)',
    borderRadius: 4,
    padding: '4px 8px',
    fontSize: 13,
    fontFamily: 'var(--font-heading, inherit)',
    cursor: 'pointer',
    outline: 'none',
  },
};
